import React, { FC, useEffect, useMemo, useState } from 'react'

import './VerifyEmail.scss'
import RouterService from 'app_services/router/routerService'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { BounceLoader } from 'react-spinners'
import AuthService from 'app_services/secure/auth/authService'
import { MdDone } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import { routingService } from 'app_services/routingService'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import UserService from 'app_services/user/userService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { VscError } from "react-icons/vsc";
const emailImage = require('app_assets/images/resources/email-verification.png')

interface IVerifyEmailProps {

}

enum ValidationState {
  SUCCESS = 'success',
  IN_PROCESS = 'in-process',
  ERROR = 'error',
}

const DELAY_LOGOUT = 5000

const VerifyEmail: FC<IVerifyEmailProps> = () => {
  const routerService = useMemo(() => new RouterService(), [])
  const authService = useMemo(() => new AuthService(), [])
  const [emailValidated, setEmailValidated] = useState<ValidationState>(ValidationState.IN_PROCESS)
  const params = useMemo(() => routerService.getParamsURLObject(),[routerService])
  const userService = useMemo(() => new UserService(), [])
  const screenNotification = useMemo(() => new ScreenNotificationsUtil(), [])
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const verifyEmail = async (token: string) => {
    const response = await authService.confirmEmail(token)
    if (response?.code === 200) {
      setEmailValidated(ValidationState.SUCCESS)
      setTimeout(() => {
        authService.logout()
        const paramRedirect = params.redirect?.length ? `?redirect=${params.redirect}` : ''
        const loginRoute = `${routingService.getPublicPath('/login')}${paramRedirect}`
        history.push(loginRoute)
      }, DELAY_LOGOUT)
    } else {
      setEmailValidated(ValidationState.ERROR)
    }
  }

  useEffect(() => {
    if (params?.token) {
      verifyEmail(params?.token)
    }
  }, [params?.token, authService])

  const resendEmail = async () => {
    if (params.username != undefined){
      setLoading(true)
      const response = await userService.sendEmailConfirmation(params.username)
      if (response?.code === 200) {
        screenNotification.showSuccessTimer({ title: "Enviado", text: "Se ha enviado un nuevo código a tu correo electrónico" })
        setTimeout(() => {
          authService.logout()
          history.push(routingService.getSecurePath())
        }, DELAY_LOGOUT)
      }
      setLoading(false)
    }
  }

  return (
    <div className="verify-email--layout">
      {emailValidated === ValidationState.SUCCESS ? (
        <div>
          <div className="verify-email--loading">
          <TextComponent type="subtitle">Tu email ha sido verificado</TextComponent>
          <MdDone
            color='var(--primary)'
            size={30} />
          </div>
          <TextComponent type="text">Te estamos redireccionando al inicio de sesión...</TextComponent>
        </div>
      ) : emailValidated === ValidationState.IN_PROCESS ? (
        <div className="verify-email--loading">
          <TextComponent type="subtitle">Verificando email...</TextComponent>
          <BounceLoader
            color='var(--secondary)'
            size={30}
          />
        </div>
      ) : (
        <div className="verify-email--error">
          <div>
            <VscError
              color='var(--red)'
              size={30}
            />
            <TextComponent type="subtitle">Ooops! Parece que el token ha expirado.</TextComponent>
          </div>
          <ButtonComponent onClick={resendEmail} loading={loading} textTransform='none' color="var(--primary)" width="fit-content">
            Enviar de nuevo
          </ButtonComponent>
        </div>
      )}
      <img className='verify-email--image' src={emailImage} alt="" />
    </div>
  )
}

export default VerifyEmail
